const blockedCountries = {
    "AL": "Albania",
    "BB": "Barbados",
    "BW": "Botswana",
    "BF": "Burkina Faso",
    "CN": "China",
    "KH": "Cambodia",
    "KY": "Cayman Islands",
    "GH": "Ghana",
    "HT": "Haiti",
    "IR": "Iran",
    "JM": "Jamaica",
    "LY": "Libya",
    "MU": "Mauritius",
    "MT": "Malta",
    "MA": "Morocco",
    "MM": "Myanmar",
    "NI": "Nicaragua",
    "KP": "North Korea",
    "PK": "Pakistan",
    "PA": "Panama",
    "PH": "Philippines",
    "SN": "Senegal",
    "SS": "South Sudan",
    "SD": "Sudan",
    "SY": "Syria",
    "UG": "Uganda",
    "YE": "Yemen",
    "ZW": "Zimbabwe",
}

export default blockedCountries;